import { log } from './logging';

/* eslint-disable camelcase */
/**
 * @name facebookTrackProduct
 *
 * @param {Object} productData - The product data passed from liquid. productData is defined in facebook-pixel-track-product.liquid
 */
export function facebookTrackProduct(productData) {
  return;
  /**
   * Check if we have products and that the facebook pixel is initialised.
   */
  if (!productData || !window.fbq) {
    return;
  }

  log('facebookTrackProduct', productData, 'ViewContent', 'crimson');

  window.fbq('track', 'ViewContent', productData);
}

/**
 * @name facebookTrackCollection
 *
 * @param {Object} results - The results from the algolia query.
 * @param {Object[]} restuts.hits - The hits from the results.
 */
export function facebookTrackCollection({ hits }) {
  return;
  /**
   * Check if we have products and that the facebook pixel is initialised.
   */
  if (!hits || !window.fbq) {
    return;
  }
  let content_category =
    window.Jbhifi.collection && window.Jbhifi.collection.handle ? window.Jbhifi.collection.handle : '';
  let content_name = window.Jbhifi.collection && window.Jbhifi.collection.title ? window.Jbhifi.collection.title : '';
  const facebookCollectionData = {
    content_ids: [],
    content_type: 'product',
    content_category: content_category,
    content_name: content_name,
  };

  facebookCollectionData.content_ids = hits.reduce((ids, { sku }) => {
    return [...ids, sku];
  }, []);

  log('facebookTrackCollection', facebookCollectionData, 'ViewContent', 'crimson');

  window.fbq('track', 'ViewContent', facebookCollectionData);
}

export function facebookTrackAddToCart(productData) {
  return;
  /**
   * Check if we have products and that the facebook pixel is initialised.
   */
  if (!productData || !window.fbq) {
    return;
  }
  const { id, quantity, name, price, category } = productData;

  const facebookProductData = {
    contents: [{ id, quantity }],
    content_category: category,
    content_name: name,
    value: Number(price),
    currency: window.Jbhifi.cart.currency,
    content_type: 'product',
  };

  log('facebookTrackAddToCart', facebookProductData, 'AddToCart', 'crimson');
  window.fbq('track', 'AddToCart', facebookProductData);
}

/**
 * @name facebookTrackPurchase
 *
 * @param {Object} gtmData - The data we send to google tag manager is also used to track the purchase event.
 * The data is defined in gtm-track.liquid via checkout.liquid.
 */
export function facebookTrackPurchase(gtmData) {
  return;
  /**
   * Check if we have products and that the facebook pixel is initialised.
   */
  if (!gtmData || !window.fbq) {
    return;
  }

  const { cartProducts } = gtmData;
  const { revenue } = gtmData.actionField;

  const facebookPurchaseData = {
    contents: [],
    value: Number(revenue) || 0,
    num_items: cartProducts.length,
    currency: window.Jbhifi.currency,
    content_type: 'product',
  };

  facebookPurchaseData.contents = cartProducts.reduce((items, { id, quantity }) => {
    return [...items, { id, quantity }];
  }, []);

  log('facebookTrackPurchase', facebookPurchaseData, 'Purchase', 'crimson');
  window.fbq('track', 'Purchase', facebookPurchaseData);
}
